import React from "react";
import { modal } from "../modal";
import { openContact } from "../../common/callUtil"
import { MasterDataReady } from "../../lib/masterData/MasterDataReady";
import { DynamicContent, isVisibleContent } from "../../common/DynamicContent";

const modal_type_contact_member_impl = props => {
  const { asset, room, eventTrackingId } = props;
  return (
    <div className="modal_type_contact_member modal_base">
      <div className="cross" onClick={() => modal.closeModal()} />
      <div className="title">
        <span>既にお申込み済みのお客様</span>
      </div>
      <div className="collection_header">
        <a
          className="item link"
          href="/mypage3/"
          target="_blank"
        >
          <img src="resource/img/post.png" />
          <div>
            <div>マイページで<span className="pc">簡単に</span>確認・変更<span className="pc">できます！</span></div>
            <div>住所変更・料金確認・連絡先変更<span className="pc">・etc・・・</span><span className="sp">等</span></div>
          </div>
          <i className="arrow fas fa-chevron-right"></i>
        </a>
      </div>
      <div className="collection">
        <a
          className="item link"
          href=""
          onClick={e => {
            e.preventDefault();
            openContact("member_key", {
              asset,
              room,
              eventTrackingId,
            });
          }}
        >
          <div>鍵紛失</div>
          <div>トラブル</div>
        </a>
        <a
          className="item link"
          href="/mypage3/?action=cancel"
          target="_blank"
        >
          <div>解約の</div>
          <div>申し出</div>
        </a>
        <a
          className="item link"
          href=""
          onClick={e => {
            e.preventDefault();
            openContact("member_contract", {
              asset,
              room,
              eventTrackingId,
            });
          }}
        >
          <div>移動・追加の</div>
          <div>検討中</div>
        </a>
        <a
          className="item link"
          href=""
          onClick={e => {
            e.preventDefault();
            openContact("member_profile", {
              asset,
              room,
              eventTrackingId,
            });
          }}
        >
          <div>ご契約</div>
          <div>名義変更</div>
        </a>
        <a
          className="item link"
          href=""
          onClick={e => {
            e.preventDefault();
            openContact("member_payment", {
              asset,
              room,
              eventTrackingId,
            });
          }}
        >
          <div>支払い方法</div>
          <div>変更</div>
        </a>

        <a
          className="item link"
          href=""
          onClick={e => {
            e.preventDefault();
            openContact("member_complaint", {
              asset,
              room,
              eventTrackingId,
            });
          }}
        >
          <div>その他ご意見・</div>
          <div>ご感想</div>
        </a>
      </div>
      <p className="collection_paragraph">
        <a onClick={e => {
          e.preventDefault();
          modal.back();
        }}>
          <img src="resource/img/s_arrow_left.png" />前の画面に戻る
        </a>
      </p>
    </div>
  );
};

export const modal_type_contact_member = props => {
  return <MasterDataReady schemaIds={["excComment"]} render={() => {
    if (isVisibleContent(masterData.excComment.modalMember)) {
      const { type } = props;
      return (
        <div className="modal_type_contact_member modal_base">
          <div className="cross" onClick={() => modal.closeModal()} />
          <DynamicContent params={masterData.excComment.modalMember} type={type}></DynamicContent>
        </div>
      );
    } else {
      return modal_type_contact_member_impl(props);
    }
  }}>
  </MasterDataReady>
};



// WEBPACK FOOTER //
// ./common/modal/modal_type_contact_member.jsx